<script setup lang="ts">

import MenuGroupItem from '@/onenetwork/layouts/components/menu/MenuGroupItem.vue'
import { computed } from 'vue'
import { useOneNetworkMenuStore } from '@/onenetwork/stores/onenetwork.store.menu'

interface Props {
  currentRoute: string[]
}
const props = defineProps<Props>()
const OneNetworkMenuStore = useOneNetworkMenuStore()

const menuItems = computed(()=>{
  return OneNetworkMenuStore.items
})

</script>

<template>
  <div class="pb-[50px]">
    <menu-group-item
      v-for="(group, index) in menuItems"
      :key="index"
      :heading="group.heading"
      :items="group.items"
      :currentRoute="props.currentRoute"
      :perm="group.perm"
    />
  </div>
</template>

<style scoped>

</style>
